"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var LocaleAbbreviation = function LocaleAbbreviation(locale) {
  var abbreviation = {
    'en-US': 'US',
    'en-GB': 'GB',
    'fr-FR': 'FR',
    'fr-CA': 'CA',
    'es-ES': 'ES',
    'de-DE': 'DE',
    'en-CA': 'CA',
    'en-AU': 'AU'
  };
  return abbreviation[locale] || locale;
};
var _default = exports.default = LocaleAbbreviation;